import React from "react";
import { Clock } from "lucide-react";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../shared/ui/LanguageSwitcher";

const PendingView = ({ authData, onLogout }) => {
  const { t } = useTranslation();

  return (
    <div className="relative min-h-screen text-white overflow-hidden">
      <video className="absolute inset-0 w-full h-full object-cover" autoPlay loop muted playsInline>
        <source src="/login-bg.mp4" type="video/mp4" />
      </video>

      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-purple-900/40 to-black/80" />

      <div className="relative z-10 min-h-screen flex items-center justify-center px-4">
        <div className="w-full max-w-md bg-white/10 backdrop-blur-xl rounded-2xl border border-white/20 shadow-[0_0_40px_rgba(255,0,255,0.25)] p-8 text-center">
          <div className="flex justify-end mb-4">
            <LanguageSwitcher />
          </div>

          <div className="w-24 h-24 bg-yellow-400/20 rounded-full flex items-center justify-center mx-auto mb-6 border border-yellow-300/40 backdrop-blur">
            <Clock className="w-12 h-12 text-pink-300" />
          </div>

          <h1 className="text-3xl font-bold mb-3">{t("customer.pending.title")}</h1>

          <p className="text-gray-200 mb-6 leading-relaxed">
            {t("customer.pending.message", { hours: 48 })}
          </p>

          <div className="bg-white/10 border border-white/10 p-4 rounded-xl mb-6 backdrop-blur-lg">
            <p className="text-pink-200 font-semibold text-lg mb-1">
              {t("customer.pending.companyLabel")}: {authData?.companyName}
            </p>
            <p className="text-gray-300 text-sm">
              {t("customer.pending.companyNumberLabel")}: {authData?.companyNumber}
            </p>
          </div>

          <button
            onClick={() => onLogout?.()}   // <-- بدل navigate("/login")
            className="w-full py-3 rounded-xl text-white font-semibold bg-gradient-to-r from-pink-500 to-red-500 hover:opacity-90 transition"
          >
            {t("auth.backToLogin")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PendingView;
